import { Link } from 'react-router-dom';

const footerLinks = {
  平台导航: [
    { label: '首页', href: '/' },
    { label: '娱乐分类', href: '/categories' },
    { label: '精品文章', href: '/articles' },
    { label: '关于我们', href: '/about' },
  ],
  娱乐分类: [
    { label: '电子竞技', href: '/categories?tab=dianjing' },
    { label: '娱乐资讯', href: '/categories?tab=yule' },
    { label: '体育赛事', href: '/categories?tab=tiyu' },
    { label: '精品游戏', href: '/categories?tab=youxi' },
  ],
  关于我们: [
    { label: '品牌介绍', href: '/about' },
    { label: '口碑声誉', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
    { label: '常见问题', href: '/#faq' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer no-underline">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-sun-fill text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-semibold text-background-50 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                太阳娱乐
              </span>
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed">
              太阳娱乐是值得信赖的综合娱乐平台，提供丰富多彩的娱乐项目与极致体验。安全稳定，服务专业，7×24小时全天候陪伴。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; 2026 太阳娱乐 版权所有 | 太阳娱乐官网
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}